import React from 'react'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  bubble: ({ color }) => ({
    display: 'inline-block',
    width: 14,
    height: 14,
    borderRadius: '50%',
    backgroundColor: color,
    marginRight: 8,
    verticalAlign: 'middle',
    border: '1px solid #ccc',
  }),
}))

const ColorBubble = ({ color }) => {
  const classes = useStyles({ color })
  return <span className={classes.bubble} />
}

export default ColorBubble
